import { Route } from "@angular/router";

export const WidgetsPaths = {
  Overview: "overzicht",
  EditTexts: "teksten/bewerken",
  Edit: (widgetId: number | string) => `bewerken/${widgetId}`,
  // VSVw-beheer: widgets van een gekozen vereniging (i.p.v. de eigen organisatie)
  OrganizationOverview: (organizationId: number | string) =>
    `organisatie/${organizationId}/overzicht`,
  OrganizationEdit: (organizationId: number | string, widgetId: number | string) =>
    `organisatie/${organizationId}/bewerken/${widgetId}`,
};

export default [
  {
    path: WidgetsPaths.Overview,
    loadComponent: () =>
      import("./pages/search-widget/search-widget.component").then((c) => c.SearchWidgetComponent),
    data: {
      breadcrumb: "Overzicht",
      title: "Widgets",
    },
  },
  {
    path: "search",
    redirectTo: WidgetsPaths.Overview,
  },
  {
    path: WidgetsPaths.EditTexts,
    loadComponent: () =>
      import("./pages/text-widget-edit/text-widget-edit.component").then(
        (c) => c.TextWidgetEditComponent
      ),
    data: {
      breadcrumb: "Widget teksten aanpassen",
      title: "Widget teksten aanpassen",
    },
  },
  {
    path: WidgetsPaths.Edit(":id"),
    loadComponent: () =>
      import("./pages/widget-edit/widget-edit.component").then((c) => c.WidgetEditComponent),
    data: {
      breadcrumb: "Widget toevoegen",
      title: "Widget toevoegen",
    },
  },
  {
    path: WidgetsPaths.OrganizationOverview(":organizationId"),
    loadComponent: () =>
      import("./pages/search-widget/search-widget.component").then((c) => c.SearchWidgetComponent),
    data: {
      breadcrumb: "Widgets vereniging",
      title: "Widgets vereniging",
    },
  },
  {
    path: WidgetsPaths.OrganizationEdit(":organizationId", ":id"),
    loadComponent: () =>
      import("./pages/widget-edit/widget-edit.component").then((c) => c.WidgetEditComponent),
    data: {
      breadcrumb: "Widget toevoegen",
      title: "Widget toevoegen",
    },
  },
] satisfies Route[];
